import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Container,
  Image,
  Label,
  Loader,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import feathersConnect from './../../providers/feathersConnect';

class DynamicRichTextSection extends Component {

  constructor (props) {
    super(props);

    this.state = {
      loading: false,
      section: null
    };

    this.PublicPagesSservice = this.props.feathers.service('/api/public-pages');
  }

  findSectionValue () {
    this.setState({
      loading: true
    });

    this.PublicPagesSservice.find({
      query: {
        name: this.props.sectionName
      }
    })
      .then(response => {
        let formattedResponse = {
          ...response,
          htmlValue: response.htmlValue.replace(/<img/g, '<img class="ui image"')
        };

        this.setState({
          section: formattedResponse,
          loading: false
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          loading: false
        });
      });
  }

  componentDidMount () {
    this.findSectionValue();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      loading,
      section
    } = this.state;

    if (loading) {
      return <Loader active inline="centered" content="Cargando Contenido"/>;
    }

    if (!section) {
      return (
        <Container style={{ padding: 16 }}>
          <Segment vertical textAlign="center">
            --- SIN CONTENIDO ---
          </Segment>
        </Container>
      );
    } else {
      function createMarkup () {
        return {
          __html: section.htmlValue
        };
      };

      return (
        <Container fluid>
          <Container style={{ padding: 16 }}>
            <div className="quill">
              <div className="ql-editor" dangerouslySetInnerHTML={createMarkup()}>

              </div>
            </div>
          </Container>
        </Container>
      );
    }
  }
}

export default feathersConnect(
  connect(
    DynamicRichTextSection.mapStateToProps,
    DynamicRichTextSection.mapDispatchToProps
  )(DynamicRichTextSection)
);



// WEBPACK FOOTER //
// ./client/components/pages/DynamicRichTextSection.js